import { Component, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, NgForm, UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ExposedUpdateMortgageEligibilityInfoReq } from 'app/interfaces/requests/Exposed/exposedUpdateMortgageEligibilityInfoReq';
import { Option } from 'app/interfaces/support/option';
import { MortgageEligibilityInfoService } from 'app/services/api/mortgageEligibilityInfo/mortgageEligibilitInfo.service';
import { DialogGeneral } from '../../../DialogGeneral';

export interface DialogMortgageEligibilityMissingOriginatingApplicationData {
    id: number;
    externalServiceId: string;
    originatingSystem: string;
}

@Component({
    selector: 'dialog-mortgage-eligibility-missing-originating-application',
    templateUrl: 'dialog-mortgage-eligibility-missing-originating-application.html',
    encapsulation: ViewEncapsulation.None,
})
export class DialogMortgageEligibilityMissingOriginatingApplicationComponent extends DialogGeneral {
    @ViewChild('ngForm') ngForm: NgForm;
    form: FormGroup;
    formEnabled = true;
    systemOptions: Option<string>[];

    /**
     * Constructor
     */
    constructor(
        private formBuilder: UntypedFormBuilder,
        private mortgageEligibilityInfoService: MortgageEligibilityInfoService,
        public dialogRef: MatDialogRef<null>,
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA)
        public data: DialogMortgageEligibilityMissingOriginatingApplicationData
    ) {
        super(dialogRef);
        this.fetchOriginatingSystemOptions();
        this.initForm();
    }

    initForm = () => {
        this.form = this.formBuilder.group({
            originatingSystemApplicationId: new FormControl('', Validators.required),
            originatingSystem: new FormControl(this.data.originatingSystem ?? '', Validators.required),
        });
    };

    fetchOriginatingSystemOptions = () => {
        this.mortgageEligibilityInfoService.getMortgageEligibilityInfoOriginatingSystems().subscribe((res: Option<string>[]) => {
            this.systemOptions = res;
        });
    };

    submit = () => {
        if (!this.form.valid) {
            return;
        }

        this.formEnabled = false;

        let request = {
            mortgageEligibilityInfo: {
                id: this.data.id,
                externalServiceId: this.data.externalServiceId,
                originatingSystem: this.form.get('originatingSystem').value,
                originatingSystemApplicationId: this.form.get('originatingSystemApplicationId').value,
            },
        } as ExposedUpdateMortgageEligibilityInfoReq;

        this.mortgageEligibilityInfoService
            .updateMortgageEligibilityInfo(request)
            .subscribe({
                next: () => {
                    this.dialogRef.close(true);
                },
            })
            .add(() => {
                this.formEnabled = true;
            });
    };
}
